









































import {defineComponent, onMounted, PropType, ref} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ILabels} from "@/apps/StudentExchangeInformationColumnWidget/models/config-viewmodel"
import {
    IInformationSectionEvent
} from "@/apps/StudentExchangeInformationColumnWidget/models/information-section-viewmodel";

export default defineComponent({
    name: "StudentExchangeInformationColumnWidget",
    props: {
        labels: {
            type: Object as PropType<ILabels>,
            required: true
        }
    },
    setup: (props: { labels: ILabels }) => {
        const {setLabels, setModalOpen, setOffset} = useActions([
            'setLabels',
            'setModalOpen',
            'setOffset'
        ])
        setLabels(props.labels)
        const {getLoading, getLabels, getInformationSections, getModalOpen, getOffset} = useGetters([
            'getLoading',
            'getLabels',
            'getInformationSections',
            'getModalOpen',
            'getOffset'
        ])
        const informationTitle = ref('')
        const informationText = ref('')
        const information = ref<Partial<CSSStyleDeclaration> | null>(null)
        const informationSectionHeader = ref<HTMLDivElement | null>(null)

        onMounted(() => {
            window.document.addEventListener('informationSectionEvent', (event) => {
                const customEvent = event as CustomEvent<IInformationSectionEvent>

                informationTitle.value = customEvent.detail.informationTitle
                informationText.value = customEvent.detail.informationText
                let elementOffset = (customEvent.detail.offset ?? 0) - (informationSectionHeader.value?.offsetHeight ?? 0)
                information.value = {marginTop: `${elementOffset}px`}
            })

            window.document.addEventListener('informationModalEvent', (event) => {
                const customEvent = event as CustomEvent<IInformationSectionEvent>

                informationTitle.value = customEvent.detail.informationTitle
                informationText.value = customEvent.detail.informationText
                
                setOffset(customEvent.detail.offset);
                setModalOpen(true);
                document.body.style.position = 'fixed';
            })
        })

        function onClose() {
            setModalOpen(false);
            
            document.body.style.position = '';
            document.documentElement.scrollTop = document.body.scrollTop = getOffset.value;
        }

        return {
            informationSectionHeader,
            getInformationSections,
            informationTitle,
            informationText,
            information,
            getLoading,
            getLabels,
            getModalOpen,
            onClose
        }
    }
})
